import React from 'react';

import type { ItemsSectionContent, SectionContent } from 'src/content/dontgiftguide/types';
import { LevelTwoContentType } from 'src/content/dontgiftguide/types';
import { dggTheme } from '../../../../styles/dggTheme';
import { Content } from '../../molecules/Content/Content';
import { ItemsSection } from '../../sectionLayouts/ItemsSection/ItemsSection';
import * as styles from './Charity.styles';

export interface CharityProps {
  title: string;
  heading: string;
  copy: string;
  sections: SectionContent[];
}

export const Charity = ({ title, heading, copy, sections }: CharityProps) => {
  return (
    <Content backgroundColor={dggTheme.colors.moodyBlue}>
      <div css={styles.root}>
        <h1 css={styles.title}>{title}</h1>
        <h2 css={styles.heading}>{heading}</h2>
        <p css={styles.copy}>{copy}</p>
        {sections.map((section: SectionContent, index: number) => {
          if (section.contentType === LevelTwoContentType.Items) {
            const itemsSection = section as ItemsSectionContent;
            return <ItemsSection key={index} items={itemsSection.items} />;
          }
          return null;
        })}
      </div>
    </Content>
  );
};
